<div class="top-section" *transloco="let t">
  <h4 class="me-2">{{ t('announcement/title') }}</h4>
  <button class="btn btn-outline-primary btn-icon" [routerLink]="links.createAnnouncement()">
    <i class="material-symbols-rounded">add_2</i> {{ t('announcement/addAnnouncement') }}
  </button>
</div>
<div class="bottom-section" #scrollContainer>
  <ng-container *ngFor="let announcement of announcementList; let last = last">
    <isophi-announcement [announcement]="announcement" [profilePicture]="true"></isophi-announcement>
    <div *ngIf="!last" class="spacer"></div>
  </ng-container>
</div>
